export default [
  {
    path: '/mng/account/embed',
    name: 'embed',
    component: () => import('@/pages/mng/analysis/assist/App.vue'),
    meta: {
      title: '微信运营',
      dataUrl: '/mng/account/embed/indexAjax?embed_type=weisheng',
      // 页面渲染之前需要加载的静态资源列表
      sourceList: {
        TCaptcha: 'https://turing.captcha.qcloud.com/TCaptcha.js',
      },
    },
    query: {
      embed_type: 'weisheng',
    },
  },
];
